import { GridLayoutContainer } from '@/features/shared/styles/layout'
import { TextButton } from '@shipt/design-system-buttons'
import { screenSizes } from '@shipt/design-system-themes'
import styled from 'styled-components'
import {
  StoresCarouselHeader,
  StoresCarouselMobileHeader,
} from '@/features/cms/components/CMS/components/BrandAmplification/StoresCarouselHeader'
import {
  createStoresCarousel,
  type StoresCarouselHeaderProps,
} from '@/features/cms/components/CMS/components/BrandAmplification/StoresCarouselBase'

const DesktopHeader = (props: StoresCarouselHeaderProps) => (
  <StoresCarouselHeader
    {...props}
    trailing={
      <TextButton
        onClick={props.handleViewAll}
        aria-label="View all stores"
        className="desktop-button"
      >
        {props.view_all_link?.text}
      </TextButton>
    }
  />
)

const CarouselWrapper = styled(GridLayoutContainer)`

  @media ${screenSizes.smDesktop} {
    --content-max-width: 1080px;
  }

  & .stores-carousel-desktop {
    margin-bottom: 1rem;
    margin-top: 1rem;

    @media ${screenSizes.lgMobile} {
      display: block;
      grid-column: full-width;

      & .tablet-button {
        display: flex;
      }
    }

    @media ${screenSizes.tablet} {
      grid-column: content;

      & .desktop-button {
        display: flex;
      }
    }
  }

  & .stores-carousel-mobile {
    grid-column: full-width;
    margin-bottom: 1rem;
  }
`

export const StoresCarouselRedesign = createStoresCarousel({
  Wrapper: CarouselWrapper,
  DesktopHeader,
  MobileHeader: StoresCarouselMobileHeader,
})
